<template>
  <!--
    ********************************************************
    ****   FORMATO NUMERO 2 CARTAS CON LINKS            ****
    ****   USADO EN PAGINAS COMO PROTOCOLOS DE LA SCJN  ****
    ********************************************************
  -->
<div  >
  <div id="Formato2" class="row" v-for="(cont,index) in contenidos" :key="index">
 <a v-if="cont.AbrirEnVisor==false" v-on:click="AbrirArchivo(cont.RRutaArchivoCarpeta,'_self')" :class="columnasContenido(cont.TamanoDeLaColumna)" >{{cont.TextoDelVinculo}}</a>
 <a v-if="cont.AbrirEnVisor==true" v-on:click="AbreElVisor(cont.RutaArchivoCarpeta)" :class="columnasContenido(cont.TamanoDeLaColumna)" >{{cont.TextoDelVinculo}}</a>

  </div>

</div>
    
</template>

<script>
import comun from "@/../static/js/comun";
export default {
    props:{
        contenidos:Array
    },
    methods:{
        columnasContenido(columnas){
            var respuesta = 'col-'+columnas
            return respuesta;
        },
        AbreElVisor: function(vinculo) {
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
      AbrirArchivo: function(vinculo,forma) {
        comun.DescargarDocumentoPDF(vinculo)
            //window.open(vinculo,forma);
        },
    }

}
</script>

<style scoped>


  #Formato2 a {
      font-size: 1.9em;
     font-family: 'Myriad';
      text-align: left;
      padding: 1em;
      transition: all 1s;
      color: black;
      text-align: left;
      font-weight: 500;
      
    }

  #Formato2 a:hover {
        transform: scale(1.1);
               
      }
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/VinculosHover.vue